import { smallScreen } from 'common/theme'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const contentFontSize = '15px'
export const commonButtonWidth = '140px'

export const StyledModal = styled(Modal)`
  * {
    font-size: ${contentFontSize};
    max-width: ${(props) => props.customWidth || '1000px'};
  }

  z-index: 10041;

  .modal-header {
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    .modal-title {
      font-size: 20px;
      font-weight: 600;
      color: white;
      margin-left: 5px;
    }
  }

  .modal-header .close {
    min-width: 0;
    margin-right: 5px;
    opacity: 0.8;
    font-size: 25px;
  }

  .modal-header .close span {
    font-size: 20px;
    color: white;
  }

  .modal-body {
    padding: 20px;
  }

  .btn-group {
    display: flex;
    gap: 15px;
    justify-content: flex-end;
    margin-top: 1rem;

    button {
      width: ${commonButtonWidth};
      max-width: ${commonButtonWidth};
    }

    span {
      text-align: right;
    }
  }

  @media (max-width: ${smallScreen}) {
    padding: 0 !important;
  }
`
